import styled from 'styled-components'

import { helpers } from 'styles'

export const Source = styled.div`
	font-size: ${helpers.font.size.small};
	display: flex;
	align-items: center;
	background-color: ${helpers.color.background};
	border: 1px solid ${helpers.color.border};
	padding: 4px 6px;
	border-radius: 4px;
	width: fit-content;
`
